
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import ConfiguracaoService from "@/service/v1/sigap/ConfiguracaoService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";

@Options({
    name: "ConfiguracaoIndex",
    components: { CardRh, KDataTable, Cadastro, Editar },
})
export default class ConfiguracaoIndex extends IndexModelTable {
    public modal_turma;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    get hasPermissaoAdmin(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.refreshTable();
    }

    created() {
        this.service = new ConfiguracaoService();

        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    search: this.search || d.search.value
                };
                return dados;
            }
        };

        this.modal_turma = 'modal_configuracao_turma_';
        this.modal_atualizar = 'modal_configuracao_update_';

        this.config.columns = [
            { data: 'id', name: 'id', class: 'desktop' },
            { data: 'nome', name: 'nome' },
            { data: 'valor', name: 'valor', class: 'desktop' },
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs = [
                {
                    targets: 3,
                    render: (row, type, val, meta) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-success btn-sm" btn-editar ' + buttom + '   data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                        if (this.hasPermissaoAdmin) {
                            texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + buttom + ' ><i class="fa fa-trash"></i> </button>';
                        }
                        return texto;
                    },
                }
            ];
        }
    }

    public tableatualizada() {
        $('[btn-editar]').click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
        $('[btn-excluir]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            this.excluirModelo(id);
        });
    }
}
